// Helpers for the SAN "Setup for" agencies feature.
// The frontend deals only in a dedicated `sanAgencyIds` field (array of agency-id strings) on the partner
// configuration. The internal `setup_for_agencies` postback parameter (marked internal in the attribution
// stack) is mapped to/from `sanAgencyIds` by the backend, so it never appears in `parameters` here.

export const SAN_AGENCY_IDS_FIELD = 'sanAgencyIds';

// "agencyid_AG000002_" — the prefix an advertiser prepends to campaign names so conversions are
// attributed to the right agency.
export const getAgencyCampaignPrefix = id => `agencyid_${id}_`;

// Normalize the dedicated field to an array (handles undefined/null before the backend surfaces it).
export const getSanAgencyIds = value => (Array.isArray(value) ? value : []);

// True when an agency is viewing a SAN config that was set up for them. Gated on the advertiser's
// `sanPartnersViewOnlyForAgencySupported` org option (resolved to the impersonated/advertiser org), so the
// read-only Agencies tab only appears where the feature is enabled.
export const isAgencyViewingSan = ({
    isAgency,
    isSAN,
    agencyOwnId,
    sanAgencyIds,
    sanViewOnlySupport,
    sanAgencyIdsSupport,
}) =>
    !!sanAgencyIdsSupport &&
    !!sanViewOnlySupport &&
    isAgency &&
    isSAN &&
    !!agencyOwnId &&
    getSanAgencyIds(sanAgencyIds).includes(agencyOwnId);
